import { useEffect } from 'react';
/**
 * Wraps a schema.org entity into a JSON-LD script and appends it to the HTML document's head.
 * Removes the script on clean-up.
 * https://developers.google.com/search/docs/guides/generate-structured-data-with-javascript#custom-javascript
 */
export const useSchema = (schema) => {
    useEffect(() => {
        if (!schema)
            return;
        const schemaWithContext = addContextToSchema(schema);
        const script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.textContent = JSON.stringify(schemaWithContext);
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, [schema]);
};
const addContextToSchema = (schema) => {
    return Object.assign({ '@context': 'https://schema.org' }, schema);
};
